<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content modal-hauteur-max-75vh">
      <error-msg-component :messages="messagesPopup"
                           :error="isErrorPopup"
                           :champsVide="champsVide"
                           :messagesChampsVide="messagesChampsVide"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="modifyIsErrorPopup"/>
      <section class="has-text-centered">
        <b-icon type="is-warning" icon="alert-outline" class="icon-modal"></b-icon>
        <p class="is-size-5 has-text-weight-bold">
          {{ messHeader }}
        </p>
        <p class="has-text-default has-text-centered mgt-20px is-size-7"
           v-if="messDescription">
           {{ messDescription }}
        </p>
        <p class="has-text-default has-text-left mgt-20px is-size-7"
           v-if="messagesHtml">
           <span v-for="(message, index) in messagesHtml" :key="index" >
              <span v-html="message"></span>
              <br/>
           </span>
        </p>
        <avertissement-msg-component :messages="msgAvertissements"
                                     v-if="msgAvertissements && msgAvertissements.length > 0"
                                     class="mgt-20px"
                                     :canClose="false"
                                     :avertissement="true"/>
        <b-field class="mgt-20px" v-if="labelCheckbox">
          <b-checkbox v-model="valueCheckBox">{{labelCheckbox}}</b-checkbox>
        </b-field>
      </section>
      <section class="mgt-10px">
        <div v-if="questions && questions.length > 0">
          <ul >
            <li v-for="ligne in questions" :key="ligne.key" class="mgt-5px">
              <b-field :label="$t(ligne.message)"
              :class="{'obligatoire':ligne.obligatoire}"
                   v-if="ligne.type ==='date'">
                <b-datepicker show-week-number
                  nearby-selectable-month-days
                  append-to-body
                  icon="calendar-today"
                  v-model="ligne.value"
                  :editable="true">
                </b-datepicker>
              </b-field>
              <b-field :label="$t(ligne.message)"
                v-else-if="ligne.type ==='texte'"
                :class="{'obligatoire':ligne.obligatoire}">
                <textarea class="textarea"
                  rows="2"
                  v-model="ligne.value">
                </textarea>
              </b-field>
              <qd-switch v-model="ligne.value" v-else>
                {{$t(ligne.message, ligne.parametres ? ligne.parametres : {})}}
              </qd-switch>
            </li>
          </ul>
        </div>
      </section>
      <br>
      <main>
        <div class="has-text-centered">
          <button class="button btn-modal-annuler is-cancel has-text-centered mg-button-modal"
                  v-if="previousButton"
                  @click="sendEvent('previousButton', true)">
            {{ (previousButton) }}
          </button>
          <button
            class="button btn-modal-annuler is-cancel has-text-centered mg-button-modal"
            @click="sendEvent('no', valueCheckBox)">
            {{ (cancel) }}
          </button>
          <button class="button is-warning has-text-centered mg-button-modal"
                  id="button-validate"
                  @click="sendEvent('yes', valueCheckBox)"
                  v-if="!questions">
            {{ (validate) }}
          </button>
          <button class="button is-warning has-text-centered mg-button-modal"
                  id="button-validate"
                  @click="validateQuestions()"
                  v-if="questions">
            {{ (validate) }}
          </button>
          <button class="button is-warning has-text-centered mg-button-modal"
                  v-if="otherButton"
                  @click="sendEvent('otherButtonSelect', valueCheckBox)">
            {{ (otherButton) }}
          </button>
        </div>
      </main>
      <footer class="subtitle modal-complement has-text-centered" v-if="messFooter">
        <p>
          {{ (messFooter) }}
        </p>
      </footer>
    </div>
  </div>
</template>

<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';
import avertissementMsgComponent from '@/components/general/avertissementMsgComponent';

export default {
  name: 'popUpPrevention',
  data() {
    return {
      valueCheckBox: true,
    };
  },
  props: {
    messagesPopup: Array,
    isErrorPopup: Boolean,
    messHeader: String,
    messFooter: String,
    cancel: String,
    validate: String,
    messDescription: String,
    otherButton: {
      type: String,
      required: false,
      default: null,
    },
    previousButton: {
      type: String,
      required: false,
      default: null,
    },
    msgAvertissements: {
      type: Array,
      required: false,
    },
    messagesChampsVide: {
      type: Array,
      required: false,
    },
    champsVide: {
      type: Array,
      required: false,
    },
    labelCheckbox: {
      type: String,
      required: false,
    },
    questions: {
      type: Array,
      required: false,
    },
    messagesHtml: {
      type: Array,
      required: false,
    },
  },
  components: {
    errorMsgComponent,
    avertissementMsgComponent,
  },
  methods: {
    sendEvent(name, value) {
      this.$emit(name, value);
    },
    validateQuestions() {
      if (this.questions === undefined) {
        this.$emit('validateQuestions', null);
        return;
      }
      const values = [];
      this.questions.forEach(ligne => {
        values.push({
          key: ligne.key,
          value: ligne.value,
        });
      });
      this.$emit('validateQuestions', values);
    },
    modifyIsErrorPopup(value) {
      this.$emit('update:isErrorPopup', value);
    },
  },
};
</script>

<style scoped>

</style>
